"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = clockSkewAdjustment;

var _incomingActivity = require("../actions/incomingActivity");

var _setClockSkewAdjustment = require("../actions/setClockSkewAdjustment");

function clockSkewAdjustment() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  if (type === _incomingActivity.INCOMING_ACTIVITY) {
    var _payload$activity = payload.activity,
        _payload$activity$cha = _payload$activity.channelData;
    _payload$activity$cha = _payload$activity$cha === void 0 ? {} : _payload$activity$cha;
    var clientTimestamp = _payload$activity$cha.clientTimestamp,
        timestamp = _payload$activity.timestamp;
    var clientSendTime = Date.parse(clientTimestamp);
    var serverTime = Date.parse(timestamp);

    if (!isNaN(clientSendTime) && !isNaN(serverTime)) {
      // The adjustment include the latency between the client and the server.
      // This means, the adjustment is always larger than the actual value.
      // And it means, after adjustment, client time will be ahead of server time.
      // And it also means, the user-originated message has higher probability to appear below bot-originated message.
      // Although it has higher probability, if the user-originated message is still sending (i.e. did not echoback with server timestamp yet),
      // the insertion-sort logic will put the bot-originated below the user-originated message.
      state = serverTime - clientSendTime;
    }
  } else if (type === _setClockSkewAdjustment.SET_CLOCK_SKEW_ADJUSTMENT) {
    // Currently, this action is for testing purpose only.
    state = payload.value;
  }

  return state;
}